<template>
  <div class="tabs-container px-4 pt-3">
    <button
      class="tab-btn"
      :class="{ active: modelValue === 'info' }"
      @click="$emit('update:modelValue', 'info')"
    >
      INFORMACIÓN
    </button>
    <button
      class="tab-btn"
      :class="{ active: modelValue === 'ciudades' }"
      @click="$emit('update:modelValue', 'ciudades')"
    >
      CIUDADES DISPONIBLES
    </button>
  </div>
</template>

<script setup>
defineProps({
  modelValue: {
    type: String,
    default: 'info',
  },
});

defineEmits(['update:modelValue']);
</script>

<style scoped>
.tabs-container {
  display: flex;
  gap: 10px;
}

.tab-btn {
  padding: 8px 24px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: transparent;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-btn:hover,
.tab-btn.active {
  background: #b49b57;
  border-color: #b49b57;
}
</style>
